import { AdminApiSchema } from "@apiUtils/index";
import { StaffApiSchema } from "@apiUtils/index";

export type Thread = AdminApiSchema.components["schemas"]["Thread"];
export type Message = AdminApiSchema.components["schemas"]["Message"];

export type AiDraft = StaffApiSchema.components["schemas"]["AiDraft"];

export type ThreadSummary = StaffApiSchema.components["schemas"]["ThreadSummaryResponse"];

export type ThreadOrdering = "-last_message_at" | "last_message_at";
export type PanelType = "data" | "user" | "messages" | "notes" | "accounts";
export type ThreadTab = Thread["state"] | "assigned_to_me" | "assigned_to_my_team";

export type ThreadQuery = {
  assignee: string[];
  state: Thread["state"][];
  user: string[];
  limit: number;
  offset: number;
  search: string;
  category: string[];
  staff_assignee: string[];
};

export type ThreadSearchParams = ThreadQuery & {
  tab: ThreadTab | null;
};

export const EMPTY_QUERY: ThreadQuery = {
  assignee: [],
  state: [],
  user: [],
  limit: 20,
  offset: 0,
  search: "",
  category: [],
  staff_assignee: [],
};

export const THREAD_STATES: Thread["state"][] = [
  "open",
  "waiting_for_response",
  "escalated",
  "closed",
];

export const THREAD_TABS: ThreadTab[] = [
  "assigned_to_me",
  "assigned_to_my_team",
  "open",
  "waiting_for_response",
  "escalated",
  "closed",
];
